/* Clean "View All" pill links — cartoon tow-car disabled to maintain strict Pure White, Slate Gray, and Bright Cobalt Blue design language and uniform section header spacing. */
(function () {
  'use strict';
})();
